import { ConfirmModal } from '@/ui'
import { Warning } from '@app/icons'
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './ExportModal.module.scss'
import { ConfigProvider, DatePicker, message } from 'antd'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { companySelectors } from '@/entity/company'
import { exportData } from '@/shared/api/rest/sickLeave/export'
import fileDownload from 'js-file-download'
import { getCurrentLanguage, t } from '@/i18next'
import ru from 'antd/es/locale/ru_RU'
import kz from 'antd/es/locale/kk_KZ'
import 'moment/locale/ru'
import 'moment/locale/kk'
const { RangePicker } = DatePicker;

export const ExportModal = ({ handleCancel }) => {
	const { t } = useTranslation()
	const company = useSelector(companySelectors.company)
	const lang = getCurrentLanguage()
	const [selectedDate, setSelectedDate] = useState([moment(), moment().add(1, 'month')])

	const locales = {
		rus: {
			moment: 'ru',
			configProvider: ru,
		},
		kz: {
			moment: 'kk',
			configProvider: kz,
		},
	}

	const [currentLocale, setCurrentLocale] = useState(locales[lang] || locales.rus)

	useEffect(() => {
		setCurrentLocale(locales[lang] || locales.rus)
		moment.locale(locales[lang]?.moment || 'ru')
	}, [lang])

	const handleDateChange = (date) => {
		setSelectedDate(date)
	}

	const handleExport = async () => {
		try {
			let startDate = selectedDate[0].format('DD.MM.YYYY')
			let endDate = selectedDate[1].format('DD.MM.YYYY')
			const params = { startDate, endDate, size: 9999, page: 0 }
			const res = await exportData({ params })
			fileDownload(res, `${company.bin}.xlsx`)
			handleCancel()
		} catch (error) {
			message.error(
				error && error.response && error.response.data ? error.response.data.message : t('unknown_error'),
				10
			)
		}
	}

	return (
		<>
			<ConfirmModal
				onProcess={handleExport}
				onCancel={handleCancel}
				cancelButtonTitle={'labor_records.cancel_text'}
				processButtonTitle={'labor_records.export'}
				hideBackButton
				priority={2}
			>
				<div className={styles.content}>
					<Warning />
					<p className={'mt-2'}>{t('sickLeave.title_export')}</p>
					<div className={styles.datePicker}>
						<ConfigProvider locale={currentLocale.configProvider}>
							<RangePicker
								onChange={handleDateChange}
								defaultValue={selectedDate}
								allowClear={false}
								format="DD.MM.YYYY"
								separator={'-'}
							/>
						</ConfigProvider>
					</div>
				</div>
			</ConfirmModal>
		</>
	)
}
